import React from 'react';
import { FormControl, InputLabel, Select, MenuItem, Typography } from '@mui/material';
import WarningIcon from '@mui/icons-material/Warning';

// Custom Select Input Component
export const CustomSelectInput = ({
    label,
    name,
    value,
    // Array of options for the select input
    options = [],
    error = '',
    helperText = '',
    onChange,
    disabled = false,
    selectProps = {},
}) => {
    // Function to determine border color based on error
    const getBorderColor = (fieldError) => {
        return fieldError ? 'red' : value ? '#0D6EFD' : '';
    };

    return (
        <FormControl fullWidth margin="dense" sx={{ flex: '1 1 23%', mt: 0 }} error={!!error}>
            <InputLabel sx={{ background: '#fff', px: 1 }}>{label}</InputLabel>
            <Select
                name={name}
                value={value}
                onChange={onChange}
                disabled={disabled}
                sx={{
                    '& .MuiOutlinedInput-notchedOutline': {
                        borderColor: getBorderColor(error),
                    },
                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                        borderColor: getBorderColor(error),
                    },
                    '& .MuiSelect-icon': {
                        color: getBorderColor(error),
                    },
                }}
                {...selectProps}
            >
                {options.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                        {option.label}
                    </MenuItem>
                ))}
            </Select>
            {error && (
                <Typography variant="caption" color="error">
                    <WarningIcon sx={{ fontSize: 16, mr: 0.5 }} /> {helperText || error}
                </Typography>
            )}
        </FormControl>
    );
};
